import useLocation from "hooks/useLocation";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Container,
  Description,
  Title,
  Details,
  Code,
  SeeDetailsBtn,
  ButtonStyled
} from "./styles";
import { ArrowUp, ArrowDown } from 'icons/';
import { ReactComponent as OopsSVG } from "assets/errors/oops.svg";

const ErrorCard = ({
  icon: Icon = OopsSVG,
  title = 'Ups!',
  description,
  isRefresh,
  isBackHome,
  isRadiusOnlyBottom,
  code,
}) => {
  
  const { t } = useTranslation()
  const { isCreators } = useLocation()

  const [showCode, setShowCode] = useState(false)

  const handleShowCode = () => setShowCode(prev => !prev)

  return (
    <Container
      $isCreators={isCreators}
      $isRadiusOnlyBottom={isRadiusOnlyBottom}
    >
      <Icon />

      <Title $isCreators={isCreators}>
        {title}
      </Title>
      
      <Description $isCreators={isCreators}>
        {description}
      </Description>

      {isRefresh && (
        <ButtonStyled variant='text' onClick={() => window.location.reload()}>
          {t('retry')}
        </ButtonStyled>
      )}

      {isBackHome && (
        <ButtonStyled variant='text' to='/'>
          {t('goToHome')}
        </ButtonStyled>
      )}

      { code && (
        <Details>
          <SeeDetailsBtn onClick={handleShowCode} variant='text'>
            {t('showDetail').toUpperCase()}
            {showCode
              ? <ArrowUp width={10} height={5}/>
              : <ArrowDown width={10} height={5}/>
            }
          </SeeDetailsBtn>

          {showCode && (
            <Code $isCreators={isCreators}>
              {code}
            </Code>
          )}
        </Details>
      )}

    </Container>
  )
}

export default ErrorCard;